import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import FilterMultiSelect from 'src/utils/FilterMultiSelect';
import getColorCode from 'src/utils/GetThemeColor';
import {
  getPlants,
  getVehicleTrackingWorkflows,
} from 'src/redux/Actions/VehicleTracking';

export default function OutwardReportMobileFilterDrawer({
  formData,
  handleDateFilterChange,
  handlePlantFilterChange,
  handleWorkflowFilterChange,
  handleResetFilter,
  handleApplyFilter,
  closeFilter,
  plantOptions,
  plantValue,
  workflowOptions,
  workflowValue,
  tenantOrganisationId,
}) {
  const dispatch = useDispatch();
  const themeColor = useSelector(
    (state) => state.AuthReducer?.userData?.tenant?.theme,
  );

  return (
    <div className="div-flex-column">
      <div
        className="filter-list-item div-flex-row div-space-between div-align-center border-bottom"
        data-testid="filter-drawer"
      >
        <span className="text-sm text-semi-bold">Filter</span>

        <button
          className="icon-btn-none"
          onClick={closeFilter}
          aria-label="Close filter"
        >
          <Close className="icon-size-sm" color={getColorCode(themeColor)} />
        </button>
      </div>

      <div className="div-flex-column div-space-between rg-20">
        <div className="filter-list-item-container-scroll div-flex-column">
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Start Date</span>

            <div className="input-wrapper">
              <input
                type="date"
                name="startDate"
                value={formData.startDate || ''}
                onChange={handleDateFilterChange}
                className="form-input-section input-icon-date"
              />

              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>

          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">End Date</span>

            <div className="input-wrapper">
              <input
                type="date"
                name="endDate"
                value={formData.endDate || ''}
                onChange={handleDateFilterChange}
                className="form-input-section input-icon-date"
              />

              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>

          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Plant</span>

            <div className="input-wrapper">
              <FilterMultiSelect
                isMulti={false}
                name="plantId"
                className="multi-select-input-section"
                value={plantValue}
                options={plantOptions}
                classNamePrefix="react-select"
                placeholder="Select Plant"
                onFocus={() => dispatch(getPlants(tenantOrganisationId))}
                onChange={handlePlantFilterChange}
              />

              <span className="form-input-section-icon">
                <ArrowRight
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                  style={{ transform: 'rotate(90deg)' }}
                />
              </span>
            </div>
          </div>

          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Workflow</span>

            <div className="input-wrapper">
              <FilterMultiSelect
                isMulti={false}
                name="workflowId"
                className="multi-select-input-section"
                value={workflowValue}
                options={workflowOptions}
                classNamePrefix="react-select"
                placeholder="Select Workflow"
                onFocus={() =>
                  dispatch(
                    getVehicleTrackingWorkflows(tenantOrganisationId, '2'),
                  )
                }
                onChange={handleWorkflowFilterChange}
              />

              <span className="form-input-section-icon">
                <ArrowRight
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                  style={{ transform: 'rotate(90deg)' }}
                />
              </span>
            </div>
          </div>
        </div>

        <div className="div-flex-row div-space-between div-align-center border-top filter-list-item footer-content-for-component">
          <button
            className={`common-btn-outlined border-${themeColor}`}
            onClick={handleResetFilter}
            data-testid="filter-reset-btn"
          >
            Reset
          </button>

          <button
            className={`common-btn theme-background-${themeColor}`}
            onClick={handleApplyFilter}
            data-testid="filter-apply-btn"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
